/**
 * DADA graphql environment URLs
 */
export const DADA_DOMAINS = {
    DEV: 'https://dada.dev.awstrp.net/graphql',
    SIT: 'https://dada.sit.awstrp.net/graphql',
    STAGE: 'https://dada.stage.awstrp.net/graphql',
    PROD: 'https://dada.awstrp.net/graphql',
};
//# sourceMappingURL=dada.js.map